import styled from 'styled-components';

export const StyledSummaryChart = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  color: #444;
`;

export const SummaryChartTitle = styled.div`
  font-size: 14px;
  font-weight: 700;
`;

export const SummaryChartStats = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`;

export const SummaryChartStat = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 16px 48px;
`;

export const SummaryChartStatLabel = styled.div`
  font-size: 16px;
  font-weight: 700;
  margin-bottom: 8px;
`;

export const SummaryChartStatValue = styled.div`
  font-size: 14px;
`;

export const SummaryChartRange = styled.div`
  font-size: 14px;
  margin-top: 8px;
`;
